import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import '../styles/relatedArticles.css';

// Automatic internal linking: shows other articles in the same category.
// This interlinks the whole site (every article gains inbound + outbound links)
// without editing existing content — the single biggest topical-authority lever.
const RelatedArticles = ({ categoryId, currentId, categorySlug, categoryName }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (!categoryId) return;
        let active = true;
        (async () => {
            const { data } = await supabase
                .from('articles')
                .select('id, title, slug, featured_image')
                .eq('category_id', categoryId)
                .neq('id', currentId)
                .not('published_at', 'is', null)
                .order('published_at', { ascending: false })
                .limit(4);
            if (active) setItems(data || []);
        })();
        return () => { active = false; };
    }, [categoryId, currentId]);

    if (!items.length) return null;

    return (
        <nav className="related-articles" aria-label="Related articles">
            <h2 className="related-title">Related reading</h2>
            <div className="related-grid">
                {items.map((a) => (
                    <Link
                        key={a.id}
                        to={`/article/${a.slug}`}
                        className="related-card"
                        style={a.featured_image ? { backgroundImage: `url(${a.featured_image})` } : {}}
                    >
                        <span className="related-card-title">{a.title}</span>
                    </Link>
                ))}
            </div>
            {categorySlug && (
                <Link to={`/category/${categorySlug}`} className="related-more">
                    More on {categoryName || 'this topic'} →
                </Link>
            )}
        </nav>
    );
};

export default RelatedArticles;
